import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { AthleteAppointment, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

type LateCancelAthleteAppointmentVars = {
  athleteAppointmentId: string;
  chargeNow: boolean;
  chargeDate: string | null;
  chargeFee: number;
  deductCredit: boolean;
  paymentMethod?: string | null;
  taxRate?: number | null;
  nonStripePaymentMethod?: string | null;
  autoPay?: boolean;
  addToNextInvoice?: boolean;
};

export default function useLateCancelAthleteAppointment(): UseMutationResult<
  AxiosResponse<AthleteAppointment>,
  AxiosError<ErrorMessage>,
  LateCancelAthleteAppointmentVars
> {
  const queryClient = useQueryClient();

  const lateCancelAthleteAppointment = ({
    athleteAppointmentId,
    ...payload
  }: LateCancelAthleteAppointmentVars): Promise<AxiosResponse<AthleteAppointment>> => {
    return client.post(`athlete-appointments/${athleteAppointmentId}/late-cancel/`, payload);
  };

  return useMutation(lateCancelAthleteAppointment, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['athleteEvents'] });
      queryClient.invalidateQueries({ queryKey: ['athleteAppointments'] });
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
      queryClient.invalidateQueries({ queryKey: 'events' });
      queryClient.invalidateQueries({ queryKey: ['totalAttended'] });
      queryClient.invalidateQueries({ queryKey: ['totalReserved'] });
    },
  });
}
